<template>
  <v-card>
    <v-card-text  v-if="statuses">
      <v-radio-group v-model="radio" :mandatory="false">
        <v-radio
          v-for="option in statuses"
          :label="option.label"
          :value="option.key"
          v-bind:key="option.key"
          @change="updateStatusAdmin"
        ></v-radio>
      </v-radio-group>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$parent.closeStatusForm">Sluiten</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ChangeStatus",
  props: ["initStatus", "statuses"],
  data() {
    return {
      radio: this.initStatus
    };
  },
  computed: {
    ...mapGetters({
      active: "activeAddress",
    })
  },
  methods: {
    ...mapActions(["updateStatusAdmin"])
  }
};
</script>

